import { useState } from "react";
import "../../assets/scss/login-forms.scss";
import Header from "../../components/header/component";
import Footer from "../../components/footer/component";
import { useTranslation } from "react-i18next";
import { validateForgetPassword } from "../../validators/genericValidator";
import { useLocation, useParams } from "react-router-dom";
import { getTenantId, getServiceCodeForgotPwd, getTenantGroupId } from "../../utils/general-config";
import { Helmet } from "react-helmet";
import { useEffect } from "react";
import { forgotPasswordAtempt } from "./actions";
import ReactLoader from "../../components/resumebuild-loader/component";
import { currentDomain } from "../../utils/general-config";
import { DomainEnum } from "../../services/enum/environment-enum";
import RBForgetPassword from "./rb";
import SSForgetPassword from "./ss";
import LSForgetPassword from "./ls";
import PSForgetPassword from "./ps";
import { getSupportEmail } from "../../utils/helpers";
import PSRForgetPassword from "./PSReskining/psr";
const ForgotPassword = () => {
  const { locale } = useParams();
  const { t } = useTranslation();

  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState(false);
  const [emailErrorMsg, setEmailErrorMsg] = useState("");
  const [buttonText, setButtonText] = useState(t("forgot_password.btn_cta"));
  const changeText = () => setButtonText(t("forgot_password.btn_cta_swap"));

  const [emailSuccess, setEmailSuccess] = useState(false);
  const [emailSuccessMsg, setEmailSuccessMsg] = useState("");
  const [isCoverLetter, setIsCoverLetter] = useState(false);

  const location = useLocation();
  const [showLoader, setShowLoader] = useState("d-none");
  useEffect(() => {
    if (location.state) {
      let checkIsCoverLetter = location.state.isCoverLetter;
      if (checkIsCoverLetter) {
        setIsCoverLetter(true);
      }
    }
  }, [location]);

  const onemailChange = (e) => {
    setEmailError(false);
    const {
      target: { value },
    } = e;
    setEmail(value);
  };

  const onSubmitClickHandler = (e) => {
    setShowLoader("d-block");
    const isValid = validateData();
    let localeVal = "en";
    if (!!locale) {
      localeVal = locale;
    }
    if (isValid) {
      const data = {
        serviceCode: getServiceCodeForgotPwd(),
        email: email.trim(),
        tenantId: getTenantId(),
        tenantgroupId: getTenantGroupId(),
        locale: localeVal,
        IsLoginAppEnabled: true,
      };

      forgotPasswordAtempt(data)
        .then((response) => {
          if (!!response) {
            if (response.isMailSent) {
              changeText();
              setEmailSuccess(true);
              setEmailSuccessMsg(t("forgot_password.forget_success_alert"));
              setEmail("");
              setShowLoader("d-none");
            } else if (
              !!response.response &&
              response.response.data.StatusCode == 400 &&
              response.response.data?.ErrorData?.SocialLoginUnableToResetPassword !== ""
            ) {
              setEmailError(true);
              setEmailErrorMsg(t("forgot_password.social_login_user"));
              setShowLoader("d-none");
            } else {
              setEmailError(true);
              setEmailErrorMsg(t("forgot_password.invalid_email").replace("##SupportEmail##", getSupportEmail()));
              setShowLoader("d-none");
            }
          } else {
            setEmailError(true);
            setEmailErrorMsg(t("forgot_password.email_error"));
            setShowLoader("d-none");
          }
        })
        .catch((error) => {
          setShowLoader("d-none");
        });
    }
  };
  const validateData = () => {
    setEmailSuccess(false);
    setEmailError(false);
    console.log("email", email.length);
    let emailValidator = validateForgetPassword(email);
    if (email.length === 0) {
      setEmailError(true);
      setEmailErrorMsg(t("sign_up.error_required_message"));
      setShowLoader("d-none");
    } else if (emailValidator.isValid === false) {
      setEmailError(true);
      setEmailErrorMsg(
        t(email === "" ? "generic_error.email_error_alert_fp" : "generic_error.email_error_alert_invalid_format")
      );
      setShowLoader("d-none");
    }
    return emailValidator.isValid;
  };
  const domain = currentDomain().toLowerCase();

  return (
    <>
      <Helmet>
        <title>{t("page_title.forgot_password")}</title>
      </Helmet>
      <ReactLoader showloader={showLoader} />
      <Header isCoverLetter={isCoverLetter} />

      {(() => {
        switch (domain) {
          case DomainEnum.PDFSIMPLI:
            return (
              <PSRForgetPassword
                emailError={emailError}
                emailErrorMsg={emailErrorMsg}
                emailSuccess={emailSuccess}
                email={email}
                onemailChange={onemailChange}
                onSubmitClickHandler={onSubmitClickHandler}
                buttonText={buttonText}
              />
            );
          case DomainEnum.WORKSIMPLI:
            return (
              <PSRForgetPassword
                emailError={emailError}
                emailErrorMsg={emailErrorMsg}
                emailSuccess={emailSuccess}
                email={email}
                onemailChange={onemailChange}
                onSubmitClickHandler={onSubmitClickHandler}
                buttonText={buttonText}
              />
            );
          case DomainEnum.LEGALSIMPLI:
            return (
              <LSForgetPassword
                emailError={emailError}
                emailErrorMsg={emailErrorMsg}
                emailSuccess={emailSuccess}
                email={email}
                onemailChange={onemailChange}
                onSubmitClickHandler={onSubmitClickHandler}
                buttonText={buttonText}
              />
            );
          case DomainEnum.SIGNSIMPLI:
            return (
              <SSForgetPassword
                emailError={emailError}
                emailErrorMsg={emailErrorMsg}
                emailSuccess={emailSuccess}
                email={email}
                onemailChange={onemailChange}
                onSubmitClickHandler={onSubmitClickHandler}
                buttonText={buttonText}
              />
            );
          default:
          case DomainEnum.RESUMEBUILD:
            return (
              <RBForgetPassword
                emailError={emailError}
                emailErrorMsg={emailErrorMsg}
                emailSuccess={emailSuccess}
                email={email}
                onemailChange={onemailChange}
                onSubmitClickHandler={onSubmitClickHandler}
                buttonText={buttonText}
              />
            );
        }
      })()}
      {domain === DomainEnum.PDFSIMPLI || domain === DomainEnum.WORKSIMPLI || domain === DomainEnum.SIGNSIMPLI ? "" : <Footer />}
    </>
  );
};

export default ForgotPassword;
